document.addEventListener("DOMContentLoaded", (event) => {
    const forms = document.querySelectorAll('form[name*="dynamic_form"]');

    forms.forEach(form => {
        form.addEventListener('submit', (e) => {
            if (form.classList.contains('is-submitting')) {
                e.preventDefault();
            }

            form.classList.add('is-submitting');
            form.querySelector('[type="submit"]').setAttribute('disabled', 'disabled');
        });
    });
});
